import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, distinct, map, mergeMap } from 'rxjs/operators';
import * as actions from './actions';
import { HostedContentFilterPolicy } from './model';
import { TenantAjaxService } from 'projects/angular-clarity/src/app/services/ajax/tenant-ajax.service';
import { retry } from 'projects/angular-clarity/src/app/pipes/retry.pipe';

@Injectable()
export class ExoHostedContentFilterPolicyEffects {
    fetchHostedContentFilterPolicy$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.fetchHostedContentFilterPolicy),
            distinct((action) => action._tenant),
            mergeMap((action) =>
                this.get(action._tenant).pipe(
                    retry(3000, 3, 'Hosted content filter policy timeout'),
                    map((data: HostedContentFilterPolicy[]) =>
                        actions.fetchHostedContentFilterPolicySuccess({ _tenant: action._tenant, data }),
                    ),
                    catchError((error) =>
                        of(actions.fetchHostedContentFilterPolicyFailure({ _tenant: action._tenant, error })),
                    ),
                ),
            ),
        ),
    );

    private get(tenant: string): Observable<HostedContentFilterPolicy[]> {
        return this.ajax.get(tenant, '/api/microsoft/powershell/exo/hosted-content-filter-policy');
    }

    updateExoHostedContentFilterPolicy$ = createEffect(() =>
        this.actions$.pipe(
            ofType(actions.updateExoHostedContentFilterPolicy),
            mergeMap((action) =>
                this.put(action._tenant, action.data).pipe(
                    map((res: any) => ({ ...res.filter((res) => res.Name === 'Default')[0] })),
                    map((data: HostedContentFilterPolicy) =>
                        actions.updateExoHostedContentFilterPolicySuccess({ _tenant: action._tenant, data }),
                    ),
                    catchError((error) =>
                        of(
                            actions.updateExoHostedContentFilterPolicyFailure({
                                _tenant: action._tenant,
                                error: { message: error.message, trace: error.trace },
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    private put(tenant: string, body: Partial<HostedContentFilterPolicy>): Observable<HostedContentFilterPolicy> {
        return this.ajax.put(tenant, '/api/microsoft/powershell/exo/hosted-content-filter-policy', body);
    }

    constructor(
        private actions$: Actions,
        private ajax: TenantAjaxService,
    ) {}
}
